import { transformUserAddress } from "../../../../data-transform";

export default function selectLegalEntitiesColumnsSpecification(config) {
    if (!config.data) return null;
    const { legalEntityList = [] } = config.data;

    let result = {};
    let tableData = [];

    legalEntityList.forEach((entity, index) => {
        let row = [];
        const rowId = entity.legalEntityId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let displayInCell = true;

            let columnValue = null;
            let columnValueData = null;
            let customEventHandler = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "legalCountry") {
                    columnValue = entity.legalCountry || "";
                }
                if (columnId === "legalEntityId") {
                    columnValue = entity.legalEntityId || "";
                }
                if (columnId === 'legalEntityName') {
                    columnValue = entity.legalEntityName || "";
                }
                if (columnId === 'billingAddress') {                   
                    columnValue = transformUserAddress(entity.billingAddress).join(", ") || "";
                }
                if (columnId === 'salesContractId') {
                    columnValue = entity.salesContractId || "";
                }
            }
            else if (columnDataType === "input") {               
                if (columnId === 'hpPONumber') {
                    columnValueData = { ...column.data };
                    columnValue = entity.hpPONumber || "";
                    columnValueData.defaultValue = columnValue;
                    if(entity.activeInDeal !== true) {
                        isDisabled = true;
                    }
                }                
                customEventHandler = config.bodyButtonsHandler.inputChangeHandler ? event => config.bodyButtonsHandler.inputChangeHandler(event, columnId, entity.legalEntityId) : null;
            }
            else if (columnDataType === "selectionCheckBox") {
                if (column.id === "activeInDeal") {
                    columnValue = entity.activeInDeal;
                }
                isDisabled = entity.disabled || false;
                customEventHandler = config.bodyButtonsHandler.inputChangeHandler ? event => config.bodyButtonsHandler.inputChangeHandler(event, columnId, entity.legalEntityId) : null
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    displayInCell: displayInCell,
                    value: columnValueData || columnValue,
                    disabledCell: isDisabled,
                    bgColor: isDisabled ? "#dbdbdb" : null,
                    clickHandler: (columnDataType !== "string" && customEventHandler) ? customEventHandler : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}